import React from 'react'
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers'
import { FormHelperText } from '@mui/material'
import moment from 'moment'

interface DateFieldProps {
  clearable?: boolean
  disabled?: boolean
  error?: boolean
  helperText?: React.ReactNode
  label?: React.ReactNode
  name?: string
  onChange?: (value?: string) => void
  /**
   * yyyy-MM-DD string
   */
  value?: string
}

export default function DateField({ clearable = false, disabled, error, helperText, label, name, onChange, value }: DateFieldProps) {
  return (
    <>
      <MuiDatePicker
        slotProps={{ field: { clearable } }}
        disabled={disabled}
        onChange={(value, _context) => {
          if (onChange) {
            onChange(value?.format('yyyy-MM-DD'))
          }
        }}
        label={label}
        value={value ? moment(value) : null}
      />

      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </>
  )
}
